import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { Container, Typography, Grid, Tooltip, useMediaQuery, Button, Box } from "@mui/material";
import { theme } from "../../styles/theme";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../../components/Footer";
import role from "../../redux/actions/role";
import SimpleSnackbar from "../../components/controls/ToastMessage";
import DownloadIcon from "@mui/icons-material/Download";
import TreemapChart from "../../components/chart/TreemapChart";
import ExperienceCards from "./ExperienceCards";
import EducationCards from "./EducationCards";
import ViewIcon from "../../assets/svg/viewicon.svg";
import BlockIcon from "@mui/icons-material/Block";
import { ImagebaseUrl } from "../../services/globalService";
import ExplainationModal from "../../components/ExplainationModal";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";

// styles for this component
const useStyles = makeStyles({
  container: {
    paddingLeft: "16px",
    paddingRight: "16px",
    paddingBottom: "3rem",
  },

  viewText: {
    // FK cleanup july 2023
    fontFamily: `${theme.font.fontFamily} !important`,
    fontStyle: `${theme.font.fontStyle} !important`,
    fontSize: "16px !important",
  },
  roletype: {
    fontFamily: "Roboto !important",
    fontStyle: "normal",
    fontWeight: "500 !important",
    fontSize: "16px !important",
    lineHeight: "24px !important",
    color: " #787878",
    paddingTop: "10px",
  },
  roletype2: {
    fontFamily: "Roboto !important",
    fontStyle: "normal",
    fontWeight: "500 !important",
    fontSize: "14px !important",
    lineHeight: "24px !important",
    color: " #787878",
    paddingTop: "10px",
  },
  roletype1: {
    // FK cleanup july 2023
    fontFamily: "Roboto !important",
    fontStyle: "normal",
    fontWeight: "400 !important",
    fontSize: "16px !important",
    lineHeight: "24px !important",
    color: " #787878",
    paddingTop: "10px",
  },
  roletext: {
    // FK cleanup july 2023
    fontStyle: "normal !important",
    fontWeight: "600 !important",
    fontSize: "24px !important",
    lineHeight: "28px !important",
    letterSpacing: "-0.02em !important",
    color: "#2F2F2F",
    textAlign: "center",
    flex: "none",
    order: 0,
    flexGrow: 0,
    paddingTop: "10px",
  },
  roletext1: {
    fontFamily: "Roboto !important",
    fontStyle: "normal",
    fontWeight: "500 !important",
    fontSize: "20px !important",
    lineHeight: "24px !important",
    color: " #787878",
    paddingTop: "10px",
    // marginLeft: "20px",
  },
  spaceflex: {
    // FK cleanup july 2023
    display: "flex",
    justifyContent: "space-between",
  },
  down_arrow: {
    // FK cleanup july 2023
    padding: "8px",
    marginTop: "10px",
  },
  btn: {
    // FK cleanup july 2023
    width: "240px !important",
    textTransform: "none !important",
    background: "#1789FC !important",
  },
  cancel_btn: {
    // FK cleanup july 2023
    width: "112px !important",
    textTransform: "none !important",
    background: "transparent !important",
    color: "#787878 !important",
    boxShadow: "none !important",
  },
  previous_btn: {
    // FK cleanup july 2023
    width: "240px !important",
    textTransform: "none !important",
    background: "transparent !important",
    color: "#1789FC !important",
    boxShadow: "none !important",
    border: "1px solid #C4C4C4 !important",
    marginRight: "10px !important",
  },
  field: {
    // FK cleanup july 2023
    minHeight: 30,
    marginTop: 8,
    backgroundColor: theme.palette.btnPrimary.light,
    "& .MuiOutlinedInput-adornedEnd": {
      paddingRight: "0px",
    },
  },
  // score number style
  scoreLeftArea: {
    // FK cleanup july 2023
    // padding: 8,
    width: "100%",
    "@media (min-width:1450px)": {
      width: "442px",
    },
  },
  scoreText: {
    // FK cleanup july 2023
    padding: "20px",
  },
  scoreMeter: {
    top: "-90px !important",
    position: "relative !important",
  },
  threeLine4: {
    color: "#787878",
    fontSize: "14px",
    lineHeight: "20px",
    textAlign: "center !important",
    fontWeight: "400 !important",
    marginTop: "10px",
  },
  textareasty: {
    // FK cleanup july 2023
    width: "100%",
    background: "#EBEFF8",
    borderRadius: "4px",
    border: "none",
    outline: "none",
    padding: "10px",
    marginTop: "10px",
    "&::placeholder": {
      fontFamily: "Roboto",
      color: "#787878",
      fontSize: "16px",
    },
  },
  textdot: {
    color: "#787878",
    fontSize: "48px !important",
    lineHeight: "20px",
    textAlign: "center !important",
    fontWeight: "600 !important",
    marginTop: "10px",
  },
  grid_root: {
    marginTop: "0px !important",
    marginLeft: "0px !important",
  },
  linksty: {
    color: "#1789FC",
    fontWeight: "500 !important",
    cursor: "pointer",
    padding: "0px",
    fontSize: "16px !important",
  },
  linksty1: {
    color: "#787878",
    fontWeight: "500 !important",
    // cursor: 'pointer',
    padding: "0px",
    fontSize: "16px !important",
  },
  datepickersty: {
    // FK cleanup july 2023
    // "& .MuiInputBase-root":{
    //     width:'533px',
    //     backgroundColor:`${theme.palette.btnPrimary.light}`,
    //     marginTop:'10px'
    // },
    width: "0px",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "0px !important",
    },
    "& .MuiInputAdornment-root ": {
      position: "absolute",
      top: "22px",
    },
  },
  grayText: {
    // FK cleanup july 2023
    color: "#787878",
  },
  link: {
    // FK cleanup july 2023

    fontFamily: "Roboto",
    fontSize: "15px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    letterSpacing: "0em",
    textalign: "left",
    textDecoration: "none !important",
    color: "#1789FC!important",
    "& .css-1ps4owl-MuiTypography-root-MuiLink-root": {
      textDecoration: "none !important",
      color: "#1789FC !important",
    },
  },
  linkCursor: {
    // FK cleanup july 2023
    cursor: "pointer",
  },
  roundedCircle: {
    // FK cleanup july 2023
    height: "12px",
    width: "12px",
    margin: "2px 3px 2px 14px",
    border: "1px solid #C4C4C4",
    borderRadius: "50%",
  },
  redLabel: {
    // FK cleanup july 2023
    color: "#DD2E2E",
  },
  // graph meter container
  graphScoreMeterContainer: {
    position: "relative",
    height: "368px",
    border: "24px solid #FFFBF6",
    borderRadius: "4px",
  },
  // graph meter canvas
  graphScoreMeterCanvas: {
    position: "relative",
    height: "320px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  // upto 900px mobile view container
  mobileGraphScoreMeterContainer: {
    // minWidth: "500px",
    position: "relative",
    border: "24px solid #FFFBF6",
    borderRadius: "4px",
  },
  // upto 900px mobile view canvas
  mobileGraphScoreMeterCanvas: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "350px",
  },
  leftSideContaint: {
    color: "#2F2F2F !important",
    fontStyle: "normal !important",
    fontWeight: "500  !important",
    fontSize: "16px !important",
    lineHeight: "24px !important",
    marginTop: "8px !important",
  },
  leftSideContaint1: {
    color: "#2F2F2F !important",
    fontStyle: "normal !important",
    fontWeight: "500  !important",
    fontSize: "14px !important",
    lineHeight: "24px !important",
    marginTop: "8px !important",
  },
  linkStyles: {
    textDecoration: "none !important",
    cursor: "pointer !important",
    color: "black",
    textOverflow: "ellipsis !important",
    overflow: "hidden",
    display: "block",
  },
  muiBtn: {
    textTransform: "none !important",
    color: "gray !important",
    fontSize: "20px !important",
    fontWeight: "400 !important",
    borderRadius: "4px !important",
    // '&:hover': {
    //   backgroundColor: '#1789FC !important',
    // },
  },
  muiBtnActive: {
    textTransform: "none !important",
    color: "primary !important",
    fontSize: "20px !important",
    fontWeight: "500 !important",
    borderRadius: "4px !important",
  },
  notAvailable: {
    border: "1px solid #C4C4C4",
    borderRadius: "4px",
    padding: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    minHeight: "20vh",
  },
  hintIconCls: {
    marginLeft: "5px",
    "&:hover": {
      cursor: "pointer",
    },
  },
});

export default function CandidateProfile() {
  const classes = useStyles();
  const navigate = useNavigate();
  const { candidateId, profileToken } = useParams();

  const dispatch = useDispatch();
  const roleState = useSelector((state) => state.role);
  const isRoleLoading = useSelector((state) => state.role.isroleLoading);
  const isAuthLoading = useSelector((state) => state.auth.isauthLoading);
  const isInvitePageLoading = useSelector((state) => state.role.isCandidateRoleLoading);
  const [skeletonLoading, setSkeletonLoading] = useState(true);
  const [snacktext, setsnacktext] = useState("");
  const [open, setOpen] = useState(false);
  const [showExplanationModal, setShowExplanationModal] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [mainData, setMainData] = useState([]);
  const [chartData, setChartData] = useState(null);
  const [updatEdeducationReportData, setUpdatedEducationReportData] = useState(null);
  const [logoUrl, setLogoUrl] = useState(null);
  const [secondaryLogo, setSecondaryLogo] = useState(null);

  const matches = useMediaQuery("(min-width:900px)");
  const isAbove500 = useMediaQuery("(min-width: 500px)");

  // Download Report
  const onDownloadReport = () => {
    let payload = {
      chartData: { data: [chartData?.plotlyData], layout: chartData?.layout },
      jobTitle: mainData?.result?.jobTitle,
      orgId: mainData?.result?.orgId,
      candidateDetails: {
        firstName: mainData?.result?.firstName,
        lastName: mainData?.result?.lastName,
        candidateId: mainData?.result?.candidateId,
        photoURL: mainData?.result?.photoURL,
        email: mainData?.result?.email,
        location: mainData?.result?.location,
        degree: mainData?.result?.degree,
        yoe: mainData?.result?.yoe,
      },
      orgLogo: mainData?.result?.orgLogo || "",
      weSummary: mainData?.result?.weSummary,
      topEducation: updatEdeducationReportData || "",
      workExperiences: mainData?.result?.weDetails?.length || 0,
      reportUrl: window.location.href,
    };
    if (mainData?.result?.candidateId) {
      dispatch(role.candidateProfileReport(payload));
    }
  };

  // Download Report Success and Open in New Tab
  useEffect(() => {
    if (roleState.candidateProfileReportSuccess) {
      window.open(roleState.candidateProfileReportSuccess, "_self");
    }
  }, [roleState.candidateProfileReportSuccess]);

  // get Tree Chart Data from child component
  const handleTreeChartData = (value) => {
    setChartData((prev) => (JSON.stringify(prev) !== JSON.stringify(value) ? value : prev));
  };

  // Handle Education Report Data
  const handleEducationReportData = (data) => {
    setUpdatedEducationReportData(data);
  };

  // Fetch Candidate Profile
  useEffect(() => {
    let payload = {
      candidateId,
      profileToken,
    };
    dispatch(role.CandidateProfile(payload));
  }, []);

  // Set Candidate Profile Data
  useEffect(() => {
    if (roleState?.CandidateProfileSuccess) {
      setMainData(roleState?.CandidateProfileSuccess?.data);
      setSkeletonLoading(false);
    }
  }, [roleState?.CandidateProfileSuccess]);

  // Set Logo URL
  useEffect(() => {
    if (mainData?.result && mainData?.result?.orgLogo == "") {
      setLogoUrl(`${process.env.REACT_APP_ASSETS_URL}techscore.svg`);
    } else {
      setLogoUrl(`${process.env.REACT_APP_ASSETS_URL}${mainData?.result?.orgLogo}`);
      setSecondaryLogo(`${process.env.REACT_APP_ASSETS_URL}powered.svg`);
    }
  }, [mainData?.result?.orgLogo]);

  // Check if Candidate Profile is not available
  useEffect(() => {
    if (roleState?.CandidateProfileFailure) {
      navigate("/inValidAccess");
    }
    // eslint-disable-next-line
  }, [roleState?.CandidateProfileFailure]);

  // console.log(mainData, "mainData");

  //extract username from linkedin
  const extractUsernameFromLink = (link) => {
    if (!link?.includes("https://")) {
      link = `https://${link}`;
    }
    const url = new URL(link);
    const pathParts = url.pathname.split("/").filter((part) => part !== ""); // Filter out empty parts
    return pathParts[pathParts.length - 1];
  };

  //handle hint click
  const handlehintClick = () => {
    setShowExplanationModal(true);
    setOpenPopup(true);
  };

  return (
    <Grid>
      {/* desktop view */}
      {matches ? (
        <div>
          <Grid
            style={{
              position: "fixed",
              top: "0",
              zIndex: "2",
              width: "100%",
              backgroundColor: "#FFFBF6",
              height: "100px",
              display: "grid",
              gridTemplateColumns: "auto 1fr",
              alignItems: "center",
            }}
          >
            {/* {mainData?.result?.candidateId && ( */}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "start", paddingLeft: "20px" }}>
              {mainData && logoUrl && secondaryLogo ? (
                <>
                  {" "}
                  <a href="https://techscore.ai" target="_blank" rel="noreferrer">
                    <img src={logoUrl} alt="LOGO" style={{ height: "42px", width: "170px" }} />
                  </a>
                  <img src={secondaryLogo} alt="LOGO" style={{ width: "170px" }} />
                </>
              ) : mainData && logoUrl ? (
                <a href="https://techscore.ai" target="_blank" rel="noreferrer">
                  <img src={logoUrl} alt="LOGO" style={{ height: "42px" }} />
                </a>
              ) : null}
            </div>
            {/* )} */}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", paddingRight: "20px" }}>
              <Typography variant="h5" style={{ fontWeight: "600" }}>
                Candidate Profile {mainData?.result?.candidateId}
              </Typography>
            </div>
          </Grid>
          {!skeletonLoading ? (
            <>
              <Container maxWidth="xl" className={classes.container}>
                <Grid style={{ marginTop: "100px" }}>
                  {!isAuthLoading && !isInvitePageLoading ? (
                    <Grid>
                      <Grid container spacing={2}>
                        {/* Left Side */}
                        <Grid item xs={1}></Grid>
                        <Grid item xs={2} xl={2} lg={2}>
                          <Grid container>
                            <Grid item xs={12} style={{ marginTop: "25px" }}>
                              <Typography variant="h6">
                                {mainData?.result?.firstName} {mainData?.result?.lastName}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: "35px" }}>
                              <img src={mainData?.result?.photoURL} alt="photoURL" style={{ width: "81%" }} />
                            </Grid>
                            <Grid item xs={12}>
                              <Typography variant="h6" style={{ marginTop: "25px", marginBottom: "10px" }}>
                                Candidate Details
                              </Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography className={classes.roletype}>Candidate ID</Typography>
                              <Typography className={classes.leftSideContaint}>
                                {mainData?.result?.candidateId}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: "10px" }}>
                              <Typography className={classes.roletype}>Degree</Typography>
                              <Typography className={classes.leftSideContaint}>{mainData?.result?.degree}</Typography>
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: "10px" }}>
                              <Typography className={classes.roletype}>Experience</Typography>
                              <Typography className={classes.leftSideContaint}>
                                {mainData?.result?.yoe} Years
                              </Typography>
                            </Grid>
                            {mainData?.result?.location && (
                              <Grid item xs={12} style={{ marginTop: "10px" }}>
                                <Typography className={classes.roletype}>Location</Typography>
                                <Typography className={classes.leftSideContaint}>
                                  {mainData?.result?.location}
                                </Typography>
                              </Grid>
                            )}
                            {mainData?.result?.email && (
                              <Grid item xs={12} style={{ marginTop: "10px" }}>
                                <Typography className={classes.roletype}>Email</Typography>
                                <Typography
                                  style={{
                                    color: "#2F2F2F",
                                    fontStyle: "normal",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                    lineHeight: "24px",
                                    marginTop: "8px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {mainData?.result?.email}
                                </Typography>
                              </Grid>
                            )}
                            {mainData?.result?.linkedInProfile && (
                              <Grid item xs={12} style={{ marginTop: "10px" }}>
                                <Typography className={classes.roletype}>LinkedIn</Typography>
                                <Typography className={classes.leftSideContaint}>
                                  {/* {mainData?.result?.linkedInProfile?.match(/\/in\/([^\/]+)/)[1]}{" "} */}
                                  {extractUsernameFromLink(mainData?.result?.linkedInProfile)}
                                  <span>
                                    <img
                                      src={ViewIcon}
                                      alt="ViewIcon"
                                      onClick={() => window.open(mainData?.result?.linkedInProfile, "_blank")}
                                      style={{ cursor: "pointer" }}
                                    />
                                  </span>
                                </Typography>
                              </Grid>
                            )}
                          </Grid>
                        </Grid>

                        <Grid item xs={8} xl={8} lg={8}>
                          <Grid container spacing={3}>
                            <Grid
                              item
                              xs={12}
                              style={{ marginTop: "25px", display: "flex", justifyContent: "space-between" }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  width: "100%",
                                  paddingRight: "24px",
                                  paddingLeft: "24px",
                                }}
                              >
                                {mainData?.result && (
                                  <Button
                                    onClick={onDownloadReport}
                                    variant="outlined"
                                    endIcon={<DownloadIcon />}
                                    sx={{ textTransform: "none" }}
                                    disabled={isRoleLoading}
                                  >
                                    Download PDF
                                  </Button>
                                )}
                              </Box>
                            </Grid>
                            {mainData?.result?.weSummary ? (
                              <Grid
                                className={classes.roletype}
                                sx={{
                                  padding: "24px",
                                  textAlign: "justify",
                                  lineHeight: "1.5 !important",
                                  // marginTop: "40px",
                                  color: "#000000 !important",
                                  minHeight: "238px",
                                }}
                              >
                                {mainData?.result?.weSummary}
                              </Grid>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  minHeight: "210px",
                                  width: "100%",
                                  marginTop: "56px",
                                }}
                                className={classes.roletype}
                              >
                                <span>
                                  <BlockIcon />
                                </span>{" "}
                                <Typography
                                  sx={{ marginLeft: "5px", marginBottom: "13px" }}
                                  className={classes.roletype}
                                >
                                  Work Experience Summary Not Available.
                                </Typography>
                              </div>
                            )}
                            <Grid
                              item
                              xs={12}
                              style={{ marginTop: "-15px", display: "flex", justifyContent: "space-between" }}
                            >
                              <Typography variant="h6">
                                Technical Skills
                                {mainData?.result?.skills?.length ? (
                                  <span>
                                    <img
                                      alt="hintImg"
                                      src={`${ImagebaseUrl}assets/questionsInformationIcon.svg`}
                                      className={classes.hintIconCls}
                                      onClick={handlehintClick}
                                    />
                                  </span>
                                ) : (
                                  ""
                                )}
                              </Typography>
                            </Grid>
                            {/* =================================== */}
                            {showExplanationModal && (
                              <ExplainationModal
                                openPopup={openPopup}
                                setOpenPopup={setOpenPopup}
                                treeMapData={mainData?.result?.skills}
                                candidateDetails={mainData?.result}
                                skillsMaster={mainData?.skillsMaster}
                              />
                            )}

                            <Box
                              style={{
                                border: "solid 1px rgba(224, 224, 224, 1)",
                                borderRadius: "8px",
                                height: "390px",
                                width: "100%",
                                padding: "20px",
                                margin: "20px",
                                // marginLeft: "0px",
                                // display: isGridVisible ? "none" : "block",
                              }}
                            >
                              <TreemapChart
                                treeMapData={mainData?.result?.skills ? [...mainData?.result?.skills] : []}
                                skillsMaster={mainData?.skillsMaster}
                                setChartData={handleTreeChartData}
                              />
                            </Box>
                          </Grid>
                        </Grid>

                        <Grid item xs={12} xl={12} lg={12}>
                          <Grid container spacing={2}>
                            <Grid item xs={1}></Grid>
                            <Grid item xs={9.9}>
                              <p style={{ borderBottom: "1px solid #C4C4C4", width: "100%" }} />
                              {/* Work Experience */}
                              <ExperienceCards
                                weDetails={mainData?.result?.weDetails}
                                skillsMaster={mainData?.skillsMaster}
                              />
                            </Grid>
                            <Grid item xs={1}></Grid>
                          </Grid>
                          <Grid container spacing={2}>
                            <Grid item xs={1}></Grid>
                            <Grid item xs={9.9}>
                              <p style={{ borderBottom: "1px solid #C4C4C4", width: "100%" }} />
                              {/* Work Experience */}
                              <EducationCards
                                education={mainData?.result?.education}
                                handleEducationReportData={handleEducationReportData}
                              />
                              <p
                                style={{
                                  borderBottom: "1px solid #C4C4C4",
                                  width: "100%",
                                  marginTop: "40px",
                                  // marginBottom: "0px",
                                }}
                              />
                              {/* <Typography className={classes.leftSideContaint}> */}
                              <Typography className={classes.roletype2}>
                                Beta Feature Disclaimer:
                                <span className={classes.leftSideContaint1}>
                                  {" "}
                                  This report is a feature in beta. Use the information displayed here with caution and
                                  cross verify it with the candidate resume. If you find any discrepancies you may
                                  report them to{" "}
                                  <a href="mailto:support@techscore.ai" style={{ color: "black" }}>
                                    support@techscore.ai
                                  </a>
                                </span>
                              </Typography>
                            </Grid>

                            <Grid item xs={1}></Grid>
                          </Grid>
                          {/* <p style={{ borderBottom: "1px solid #C4C4C4", width: "100%" }} /> */}
                        </Grid>
                      </Grid>
                    </Grid>
                  ) : null}
                </Grid>
              </Container>
              {/* <Footer /> */}

              <SimpleSnackbar open={open} setOpen={setOpen} text={snacktext} />
            </>
          ) : (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Grid container spacing={1} mt={"80px"} width={"80%"}>
                <Grid item xs={12} md={12}>
                  <Grid item xs={12} md={12} mt={5}>
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                      <Skeleton variant="text" sx={{ fontSize: "40px", width: "200px" }} />
                      <Skeleton variant="text" sx={{ fontSize: "40px", width: "200px" }} />
                    </Box>
                  </Grid>

                  <Grid container item xs={12} md={12} columnSpacing={4} mt={4}>
                    <Grid container item xs={3} md={3}>
                      <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="170px" height="180px" />
                      <Skeleton variant="text" sx={{ fontSize: "12px", width: "100%", marginBottom: "20px" }} />

                      {Array.from({ length: 4 }).map((_, index) => (
                        <Stack width={"100%"} height={"60px"} spacing={0.8}>
                          <Skeleton key={index} variant="text" sx={{ fontSize: "22px", width: "80%" }} />
                          <Skeleton key={index} variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        </Stack>
                      ))}
                    </Grid>

                    <Grid container item xs={9} md={9}>
                      <Grid item xs={12} md={12}>
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "40%" }} />
                      </Grid>

                      <Grid item xs={12} md={12} mt={6}>
                        <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="100%" height="400px" />
                      </Grid>
                    </Grid>
                  </Grid>
                  <p style={{ borderBottom: "1px solid #C4C4C4", marginTop: "25px", marginBottom: "25px" }} />

                  <Grid container item xs={12} md={12} columnSpacing={4}>
                    <Grid item xs={12} md={12} mt={3}>
                      <Skeleton variant="text" sx={{ fontSize: "40px", width: "10%" }} />

                      <Stack spacing={2} mt={4}>
                        <Skeleton variant="rounded" width={"100%"} height={"200px"} />
                        <Skeleton variant="rounded" width={"100%"} height={"200px"} />
                        <Skeleton variant="rounded" width={"100%"} height={"200px"} />
                      </Stack>
                    </Grid>
                  </Grid>
                  <p style={{ borderBottom: "1px solid #C4C4C4", marginTop: "25px", marginBottom: "25px" }} />
                  <Grid container item xs={12} md={12}>
                    <Grid item xs={12} md={12} mt={1}>
                      <Skeleton variant="text" sx={{ fontSize: "40px", width: "30%" }} />

                      <Grid item xs={12} md={12} mt={2}>
                        {Array.from({ length: 3 }).map((_, index) => (
                          <Box sx={{ display: "flex", justifyContent: "flex-start", gap: "14px" }}>
                            <Skeleton variant="text" sx={{ fontSize: "25px", width: "10%" }} />
                            <Skeleton variant="text" sx={{ fontSize: "25px", width: "90%" }} />
                          </Box>
                        ))}
                      </Grid>
                    </Grid>
                  </Grid>
                  <p style={{ borderBottom: "1px solid #C4C4C4", marginTop: "25px", marginBottom: "25px" }} />

                  <Grid container item xs={12} md={12} rowSpacing={5} columnSpacing={4} mb={5}>
                    <Grid item xs={12} md={12}>
                      <Stack spacing={0.8}>
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "45%" }} />
                      </Stack>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          )}
        </div>
      ) : (
        <div>
          {/* mobile and tablet view */}
          <Grid
            style={{
              position: "fixed",
              top: "0",
              zIndex: "2",
              width: "100%",
              backgroundColor: "#FFFBF6",
              height: "100px",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "2px" }}>
              {mainData && logoUrl && secondaryLogo ? (
                <>
                  {" "}
                  <a href="https://techscore.ai" target="_blank" rel="noreferrer">
                    <img src={logoUrl} alt="LOGO" style={{ height: "42px", width: "170px" }} />
                  </a>
                  <img src={secondaryLogo} alt="LOGO" style={{ width: "170px" }} />
                </>
              ) : mainData && logoUrl ? (
                <a href="https://techscore.ai" target="_blank" rel="noreferrer">
                  <img src={logoUrl} alt="LOGO" style={{ height: "42px" }} />
                </a>
              ) : null}
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <Typography variant="h6" style={{ fontWeight: "600", padding: "1px" }}>
                Candidate Profile {mainData?.result?.candidateId}
              </Typography>
            </div>
          </Grid>
          {!skeletonLoading ? (
            <>
              <Container maxWidth="xl" className={classes.container}>
                <Grid style={{ marginTop: "100px" }}>
                  {!isAuthLoading && !isInvitePageLoading ? (
                    <Grid container spacing={2}>
                      {/* Left Side */}
                      <Grid
                        lg={4}
                        md={12}
                        sm={12}
                        xs={12}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          marginTop: "40px",
                        }}
                      >
                        <Grid item lg={12} md={12} sm={12} xs={12} style={{ marginTop: "7px" }}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              width: "100%",
                            }}
                          >
                            {mainData?.result && (
                              <Button
                                onClick={onDownloadReport}
                                variant="outlined"
                                endIcon={<DownloadIcon />}
                                sx={{ textTransform: "none" }}
                                disabled={isRoleLoading}
                              >
                                Download PDF
                              </Button>
                            )}
                            <Typography variant="h6" sx={{ textAlign: "center", marginTop: "7px" }}>
                              {mainData?.result?.firstName} {mainData?.result?.lastName}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          style={{ marginTop: "35px", display: "flex", justifyContent: "center" }}
                        >
                          <img src={mainData?.result?.photoURL} alt="photoURL" style={{ width: "50%" }} />
                        </Grid>
                      </Grid>

                      <Grid item lg={12} md={12} sm={12}>
                        <Typography variant="h6" style={{ marginTop: "25px", marginBottom: "10px" }}>
                          Candidate Details
                        </Typography>
                      </Grid>
                      <Grid container lg={8} md={12} sm={12} xs={12} style={{ paddingLeft: "15px" }}>
                        <Grid item lg={4} md={4} sm={4} xs={4}>
                          <Typography className={classes.roletype}>Candidate ID</Typography>
                          <Typography className={classes.leftSideContaint}>{mainData?.result?.candidateId}</Typography>
                        </Grid>
                        <Grid item lg={4} md={4} sm={4} xs={4}>
                          <Typography className={classes.roletype}>Degree</Typography>
                          <Typography className={classes.leftSideContaint}>{mainData?.result?.degree}</Typography>
                        </Grid>
                        <Grid item lg={4} md={4} sm={4} xs={4}>
                          <Typography className={classes.roletype}>Experience</Typography>
                          <Typography className={classes.leftSideContaint}>
                            <Typography className={classes.leftSideContaint}>{mainData?.result?.yoe} Years</Typography>
                            Years
                          </Typography>
                        </Grid>
                        {mainData?.result?.location && (
                          <Grid item lg={4} md={4} sm={4} xs={4}>
                            <Typography className={classes.roletype}>Location</Typography>
                            <Typography className={classes.leftSideContaint}>{mainData?.result?.location}</Typography>
                          </Grid>
                        )}
                        {mainData?.result?.email && (
                          <Grid item lg={4} md={4} sm={4} xs={4}>
                            <Typography className={classes.roletype}>Email</Typography>
                            <Typography className={classes.leftSideContaint}>{mainData?.result?.email}</Typography>
                          </Grid>
                        )}
                        {mainData?.result?.linkedInProfile && (
                          <Grid item lg={4} md={4} sm={4} xs={4}>
                            <Typography className={classes.roletype}>LinkedIn</Typography>
                            <Typography className={classes.leftSideContaint}>
                              {/* {mainData?.result?.linkedInProfile?.match(/\/in\/([^\/]+)/)[1]}{" "} */}
                              {extractUsernameFromLink(mainData?.result?.linkedInProfile)}

                              <span>
                                <img
                                  src={ViewIcon}
                                  alt="ViewIcon"
                                  onClick={() => window.open(mainData?.result?.linkedInProfile, "_blank")}
                                  style={{ cursor: "pointer" }}
                                />
                              </span>
                            </Typography>
                          </Grid>
                        )}
                      </Grid>
                      {mainData?.result?.weSummary ? (
                        <Grid
                          className={classes.roletype}
                          sx={{
                            padding: "16px",
                            paddingRight: "0px",
                            textAlign: "justify",
                            lineHeight: "1.5 !important",
                            color: "#000000 !important",
                            marginTop: "20px",
                            marginBottom: "20px",
                          }}
                        >
                          {mainData?.result?.weSummary}
                        </Grid>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            minHeight: "210px",
                            width: "100%",
                            marginTop: "56px",
                          }}
                          className={classes.roletype}
                        >
                          <span>
                            <BlockIcon />
                          </span>{" "}
                          <Typography sx={{ marginLeft: "5px", marginBottom: "13px" }} className={classes.roletype}>
                            Work Experience Summary Not Available.
                          </Typography>
                        </div>
                      )}
                      <Grid
                        item
                        xs={12}
                        style={{ marginBottom: "20px", display: "flex", justifyContent: "space-between" }}
                      >
                        <Typography variant="h6">
                          Technical Skills
                          {mainData?.result?.skills?.length ? (
                            <span>
                              <img
                                alt="hintImg"
                                src={`${ImagebaseUrl}assets/questionsInformationIcon.svg`}
                                className={classes.hintIconCls}
                                onClick={handlehintClick}
                              />
                            </span>
                          ) : (
                            ""
                          )}
                        </Typography>
                      </Grid>
                      {showExplanationModal && (
                        <ExplainationModal
                          openPopup={openPopup}
                          setOpenPopup={setOpenPopup}
                          treeMapData={mainData?.result?.skills}
                          candidateDetails={mainData?.result}
                          skillsMaster={mainData?.skillsMaster}
                        />
                      )}
                      <Box
                        style={{
                          border: "solid 1px rgba(224, 224, 224, 1)",
                          borderRadius: "8px",
                          height: "515px",
                          width: "100%",
                          // padding: "20px",
                          // margin: "20px",
                          marginLeft: "15px",
                          // display: isGridVisible ? "none" : "block",
                        }}
                      >
                        <TreemapChart
                          treeMapData={mainData?.result?.skills ? [...mainData?.result?.skills] : []}
                          skillsMaster={mainData?.skillsMaster}
                          setChartData={handleTreeChartData}
                        />
                      </Box>

                      <Grid item xs={12} xl={8} lg={8}>
                        <Grid item xs={12} xl={12} lg={12}>
                          <Grid container spacing={2}>
                            <Grid item xs={1}></Grid>
                            <Grid item xs={12}>
                              <p style={{ borderBottom: "1px solid #C4C4C4", width: "100%" }} />
                              {/* Work Experience */}
                              <ExperienceCards
                                weDetails={mainData?.result?.weDetails}
                                skillsMaster={mainData?.skillsMaster}
                              />
                            </Grid>
                            <Grid item xs={1}></Grid>
                          </Grid>
                          <Grid container spacing={2}>
                            <Grid item xs={1}></Grid>
                            <Grid item xs={12}>
                              <p style={{ borderBottom: "1px solid #C4C4C4", width: "100%" }} />
                              {/* Work Experience */}
                              <EducationCards
                                education={mainData?.result?.education}
                                handleEducationReportData={handleEducationReportData}
                              />
                            </Grid>
                            <Grid item xs={1}></Grid>
                          </Grid>
                          <p style={{ borderBottom: "1px solid #C4C4C4", width: "100%" }} />

                          <Typography className={classes.roletype2}>
                            Beta Feature Disclaimer:
                            <span className={classes.leftSideContaint1}>
                              {" "}
                              This report is a feature in beta. Use the information displayed here with caution and
                              cross verify it with the candidate resume. If you find any discrepancies you may report
                              them to{" "}
                              <a href="mailto:support@techscore.ai" style={{ color: "black" }}>
                                support@techscore.ai
                              </a>
                            </span>
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  ) : null}
                </Grid>
              </Container>
            </>
          ) : (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Grid container spacing={1} mt={"80px"} width={"80%"}>
                <Grid item xs={12} md={12}>
                  <Grid item xs={12} md={12} mt={5}>
                    <Box
                      sx={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}
                    >
                      <Skeleton variant="text" sx={{ fontSize: "40px", width: "200px" }} />
                      <Skeleton variant="text" sx={{ fontSize: "40px", width: "200px" }} />
                    </Box>
                  </Grid>
                  {/* <p style={{ borderBottom: "1px solid #C4C4C4", marginTop: "25px", marginBottom: "25px" }} /> */}

                  <Grid container item xs={12} md={12} columnSpacing={4} mt={4}>
                    <Grid container item xs={12} md={12} justifyContent="center">
                      <stack>
                        <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="170px" height="180px" />
                      </stack>

                      <Grid container item xs={12} md={12} spacing={2} mt={2}>
                        <Grid item xs={12} md={12}>
                          <Grid container spacing={3}>
                            <Grid item xs={4} md={4}>
                              <Stack spacing={0.8}>
                                <Skeleton variant="text" sx={{ fontSize: "25px", width: "70%" }} />
                              </Stack>
                            </Grid>
                          </Grid>
                          <Grid container spacing={3} mt={2}>
                            {[...Array(3)].map((_, index) => (
                              <Grid item xs={4} md={4} key={index}>
                                <Stack spacing={0.8}>
                                  <Skeleton variant="text" sx={{ fontSize: "20px", width: "50%" }} />
                                  <Skeleton variant="text" sx={{ fontSize: "22px", width: "100%" }} />
                                </Stack>
                              </Grid>
                            ))}
                          </Grid>
                          <Grid container spacing={3} marginTop={2}>
                            <Grid item xs={4} md={4}>
                              <Stack spacing={0.8}>
                                <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                                <Skeleton variant="text" sx={{ fontSize: "22px", width: "100%" }} />
                              </Stack>
                            </Grid>
                            <Grid item xs={8} md={8}>
                              <Stack spacing={0.8}>
                                <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                                <Skeleton variant="text" sx={{ fontSize: "22px", width: "100%" }} />
                              </Stack>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid container item xs={12} md={12} mt={4}>
                      <Grid item xs={12} md={12}>
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "40%" }} />
                      </Grid>

                      <Grid item xs={12} md={12} mt={6}>
                        <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="100%" height="400px" />
                      </Grid>
                    </Grid>
                  </Grid>
                  <p style={{ borderBottom: "1px solid #C4C4C4", marginTop: "25px", marginBottom: "25px" }} />

                  {/* <Grid container item xs={12} md={12} rowSpacing={5} columnSpacing={4}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.8}>
                      <Skeleton variant="text" sx={{ fontSize: "25px", width: "30%" }} />
                      <Skeleton variant="text" sx={{ fontSize: "20px", width: "45%" }} />
                      <Skeleton variant="text" sx={{ fontSize: "20px", width: "45%" }} />
                      <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                    </Stack>
                  </Grid>
                </Grid>
                <p style={{ borderBottom: "1px solid #C4C4C4", marginTop: "25px", marginBottom: "25px" }} /> */}

                  <Grid container item xs={12} md={12} columnSpacing={4}>
                    <Grid item xs={12} md={12} mt={3}>
                      <Skeleton variant="text" sx={{ fontSize: "40px", width: "10%" }} />

                      {/* <Skeleton sx={{ bgcolor: "grey.300" }} variant="rectangular" width="100%" height="400px" /> */}
                      <Stack spacing={2} mt={4}>
                        <Skeleton variant="rounded" width={"100%"} height={"200px"} />
                        <Skeleton variant="rounded" width={"100%"} height={"200px"} />
                        <Skeleton variant="rounded" width={"100%"} height={"200px"} />
                      </Stack>
                    </Grid>
                  </Grid>
                  <p style={{ borderBottom: "1px solid #C4C4C4", marginTop: "25px", marginBottom: "25px" }} />
                  <Grid container item xs={12} md={12}>
                    <Grid item xs={12} md={12} mt={1}>
                      <Skeleton variant="text" sx={{ fontSize: "40px", width: "30%" }} />

                      <Grid item xs={12} md={12} mt={2}>
                        {Array.from({ length: 3 }).map((_, index) => (
                          <Box sx={{ display: "flex", justifyContent: "flex-start", gap: "14px" }}>
                            <Skeleton variant="text" sx={{ fontSize: "25px", width: "10%" }} />
                            <Skeleton variant="text" sx={{ fontSize: "25px", width: "90%" }} />
                          </Box>
                        ))}
                      </Grid>
                    </Grid>
                  </Grid>
                  <p style={{ borderBottom: "1px solid #C4C4C4", marginTop: "25px", marginBottom: "25px" }} />

                  <Grid container item xs={12} md={12} rowSpacing={5} columnSpacing={4} mb={5}>
                    <Grid item xs={12} md={12}>
                      <Stack spacing={0.8}>
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "100%" }} />
                        <Skeleton variant="text" sx={{ fontSize: "20px", width: "45%" }} />
                      </Stack>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          )}
        </div>
      )}

      <Footer />
    </Grid>
  );
}
